// types
import { IFormFieldTypes, IFormFieldRow } from '@/types/form';
// validations
import validations from '@/validations';
const {
  maxLength,
  required,
  composeValidators,
  validFirstName,
  validLastName,
  email,
} = validations;

export const customFieldsOrdIds = [
  'bbf4f258-b741-407b-aac5-94f689fdd69c', // pre-prod - Zuddl-PreProd
  'f09870d7-49e7-4855-b51e-dcb45e8116b8', // prod - Rocketlane
  '22df93ff-4b15-4349-85ba-aa687821f074', // prod - Zylo
];

export const NAME_FORM_FIELDS = (
  shouldUpdateCustomField = false,
  organizationId = '',
) =>
  [
    {
      fields: [
        {
          name: 'firstName',
          label: 'First name',
          fieldType: IFormFieldTypes.LANDING_PAGE_INPUT,
          maxLength: 50,
          tooltip: '',
          widthRatio: 1,
          validate: composeValidators(required, validFirstName, maxLength(50)),
        },
      ],
    },
    {
      fields: [
        {
          name: 'lastName',
          label: 'Last name',
          fieldType: IFormFieldTypes.LANDING_PAGE_INPUT,
          widthRatio: 1,
          maxLength: 50,
          tooltip: '',
          validate: composeValidators(required, validLastName, maxLength(50)),
        },
      ],
    },
    {
      fields: [
        {
          name: 'email',
          label: customFieldsOrdIds.includes(organizationId)
            ? 'Business Email'
            : 'Email address',
          fieldType: IFormFieldTypes.LANDING_PAGE_INPUT,
          widthRatio: 1,
          maxLength: 150,
          tooltip: '',
          validate: composeValidators(required, email, maxLength(150)),
          readOnly: shouldUpdateCustomField,
        },
      ],
    },
  ] as IFormFieldRow[];

export const formatCustomFieldValues = (
  currentUserCustomField,
  registrationCustomFieldList,
) => {
  let customFieldValues = JSON.parse(currentUserCustomField);
  const dropDownFields =
    registrationCustomFieldList &&
    registrationCustomFieldList.filter(item => item.fieldType === 'DROPDOWN');
  dropDownFields &&
    dropDownFields.map(field => {
      if (field.labelName in customFieldValues) {
        if (
          JSON.stringify(customFieldValues[field.labelName]).includes('value')
        ) {
          customFieldValues[field.labelName] =
            customFieldValues[field.labelName].value;
        }
      }
    });
  return customFieldValues;
};
